import React from 'react';
import { motion } from 'framer-motion';
import { LandmarkIcon } from 'lucide-react';
import { modules } from '../data/modules';
export function ModulesSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-156" data-mp="1ivl1k02ld0p1">
      <div className="mx-auto max-w-6xl px-4" data-id="element-157" data-mp="1itgu585hhjk0">
        <div className="text-center" data-id="element-158" data-mp="1dx9shrk4eu7v">
          <span className="inline-flex items-center gap-2 rounded-full border border-teal/25 bg-white px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-teal" data-id="element-159" data-mp="1dybakfzk0gz3">
            <LandmarkIcon className="h-4 w-4" data-id="element-160" data-mp="26mgxn9e2yi23" /> Los 6 tomos
          </span>
          <h2 id="modules-title" className="mx-auto mt-4 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-161" data-mp="21l9rferl5qxj">
            Un tomo por cada dimensión de la Gestión Cultural argentina
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-162" data-mp="q8h20am9pekn">
          {modules.map(([number, title, description, result, Icon, tags], index) => <motion.article key={title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.12
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-2xl border border-line bg-white p-6 text-ink shadow-card" data-id="element-163" data-mp="1iupaakpbxcs1" data-mpi={index}>
              <div className="flex items-start justify-between gap-4" data-id="element-164" data-mp="104hdekc83ika">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-petrol text-gold" data-id="element-165" data-mp="14v7g1pt9l7ba">
                  <Icon className="h-6 w-6" data-id="element-166" data-mp="q736bbc6w64n" />
                </span>
                <span className="font-display text-2xl font-bold text-line" data-id="element-167" data-mp="q4qe85cpwfdv">Tomo {number}</span>
              </div>
              <h3 className="mt-5 text-xl font-bold text-ink" data-id="element-168" data-mp="h5vbx4csnpfu">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-169" data-mp="h7zmg5577mp3">{description}</p>
              <p className="mt-4 flex-1 rounded-xl border border-teal/20 bg-aquaSoft p-3 text-sm leading-relaxed text-teal" data-id="element-170" data-mp="l6owpouxwo4i">
                <b className="font-extrabold" data-id="element-171" data-mp="2nvynq30l1dfh">Resultado: </b>
                {result}
              </p>
              <p className="mt-5 border-t border-line pt-4 text-[10px] font-extrabold uppercase tracking-[.1em] text-muted" data-id="element-172" data-mp="2e4c0t9evtpww">
                {tags}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}